import moment from "moment"
moment.locale("zh-cn")
export function getSearchParm(obj){
    return new Proxy(obj,{
        get(target,key){
            if(target[key] == ""||target==null){
                return undefined
            }
		    if((key == "starttime"||key=="endtime") && moment.isMoment(target[key])){
				return target[key].format("YYYY-MM-DD"); 
		    }
			return target[key]
	    }
    })
}


export const columns = [
    {dataIndex:"id",key:"id",title:"序号",scopedSlots: { customRender: 'tindex' }},
    {dataIndex:"starttime",key:"starttime",title:"开始时间"},
    {dataIndex:"endtime",key:"endtime",title:"开始时间"},
    {dataIndex:"name",key:"name",title:"姓名",width:"100px"},
    {dataIndex:"idcard",key:"idcard",title:"身份证号码"},
    {dataIndex:"workplace",key:"workplace",title:"所属工地",width:"100px",
		myRender:"workplace",scopedSlots: { customRender: 'workplace' }
    },
    {dataIndex:"yingfu",key:"yingfu",title:"应付金额",width:"100px"},
    {dataIndex:"clyuzhi",key:"clyuzhi",title:"预支金额",width:"100px"},
    {dataIndex:"jieyu",key:"jieyu",title:"结余金额",width:"100px"},
    {key:"action",title:"操作",scopedSlots:{customRender:"action"},width:'200px'}
]


